var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.353,
    height: 63.656,
    viewBox: "0 0 63.353 63.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DubblePagineringRechts",
    transform: "translate(-794.169 -372.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M11.21,31.82,35.821,7.753a4.461,4.461,0,0,0,0-6.424,4.741,4.741,0,0,0-6.584,0L1.354,28.6a4.471,4.471,0,0,0-.136,6.273l28,27.459a4.748,4.748,0,0,0,6.584,0,4.461,4.461,0,0,0,0-6.424Z",
    transform: "translate(831.354 436.124) rotate(180)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back-2",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M11.21,31.82,35.821,7.753a4.461,4.461,0,0,0,0-6.424,4.741,4.741,0,0,0-6.584,0L1.354,28.6a4.471,4.471,0,0,0-.136,6.273l28,27.459a4.748,4.748,0,0,0,6.584,0,4.461,4.461,0,0,0,0-6.424Z",
    transform: "translate(857.521 436.124) rotate(180)",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronRight);
export default __webpack_public_path__ + "static/media/DoubleChevronRight.597a72d2000edc3d183fd06b42ba3ab9.svg";
export { ForwardRef as ReactComponent };